import { ajax } from "lib/observable";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import siteConfig from "site-config";
import { SIZE_FAMILIES } from "constants/action-types";
import { add as snackbarAdd } from "../actions/snackbars";
import { formatMessage } from "lib/globalize-util";
import { stringify } from "querystring";

const sortAlphabetically = (data) => {
    if (Array.isArray(data)) {
        return data.slice().sort((f1, f2) => f1.name.toLowerCase().localeCompare(f2.name.toLowerCase()));
    } else {
        return [];
    }
};

export const fetchSizeFamiliesEpic = (action$, store) =>
    action$.ofType(SIZE_FAMILIES.FETCH.START).switchMap(() => {
        const query = {
            __limit: 200,
        };
        return ajax(`${siteConfig.api}/api/v3.0/items/sizes/families?${stringify(query)}`)
            .flatMap(({ response }) => {
                const sortedResponse = sortAlphabetically(response);
                return [
                    {
                        payload: sortedResponse,
                        type: SIZE_FAMILIES.FETCH.SUCCESS,
                    },
                ];
            })
            .catch((error) =>
                Observable.merge(
                    Observable.of({
                        error: true,
                        payload: error,
                        type: SIZE_FAMILIES.FETCH.SUCCESS,
                    }),
                    Observable.of(snackbarAdd({ message: formatMessage("There was an error fetching size families") }))
                )
            );
    });

export const createSizeFamiliesEpic = (action$, store) =>
    action$
        .ofType(SIZE_FAMILIES.CREATE.START)
        .map((action) => {
            return action.payload;
        })
        .concatMap((sizeFamily) => {
            return ajax({
                method: "POST",
                body: sizeFamily,
                url: `${siteConfig.api}/api/v3.0/items/sizes/families`,
            })
                .flatMap(({ response }) => [
                    {
                        payload: response,
                        type: SIZE_FAMILIES.CREATE.COMPLETED,
                    },
                ])
                .catch((error) =>
                    Observable.merge(
                        Observable.of({
                            error: true,
                            payload: error,
                            type: SIZE_FAMILIES.CREATE.COMPLETED,
                        }),
                        Observable.of(
                            snackbarAdd({ message: formatMessage("There was an error creating size family") })
                        )
                    )
                );
        });

export const deleteSizeFamiliesEpic = (action$, store) =>
    action$
        .ofType(SIZE_FAMILIES.DELETE.START)
        .map((action) => {
            return action.payload;
        })
        .concatMap((id) => {
            return ajax({
                url: `${siteConfig.api}/api/v3.0/items/sizes/families/${id}`,
                method: "DELETE",
            })
                .flatMap(({ response }) => {
                    return [
                        {
                            payload: response,
                            type: SIZE_FAMILIES.DELETE.COMPLETED,
                        },
                    ];
                })
                .catch((error) => {
                    return Observable.merge(
                        Observable.of({
                            error: true,
                            payload: error,
                            type: SIZE_FAMILIES.DELETE.COMPLETED,
                        }),
                        Observable.of(
                            snackbarAdd({ message: formatMessage("There was an error deleting size family") })
                        )
                    );
                });
        });

export const updateSizeFamiliesEpic = (action$, store) =>
    action$
        .ofType(SIZE_FAMILIES.UPDATE.START)
        .map((action) => {
            return action.payload;
        })
        .concatMap((sizeFamily) => {
            const { _id } = sizeFamily;
            return ajax({
                method: "PUT",
                body: sizeFamily,
                url: `${siteConfig.api}/api/v3.0/items/sizes/families/${_id}`,
            })
                .flatMap(({ response }) => [
                    {
                        payload: response,
                        type: SIZE_FAMILIES.UPDATE.COMPLETED,
                    },
                ])
                .catch((error) =>
                    Observable.merge(
                        Observable.of({
                            error: true,
                            payload: error,
                            type: SIZE_FAMILIES.UPDATE.COMPLETED,
                        }),
                        Observable.of(
                            snackbarAdd({ message: formatMessage("There was an error updating size family") })
                        )
                    )
                );
        });
